/**
 * Appointments List Page
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Button } from "@jourfx/ui";
import { AppointmentList } from "@/components/scheduling/appointments/AppointmentList";
import { useAuth } from "@/hooks/useAuth";

export const Route = createFileRoute("/_authenticated/appointments/")({
  component: AppointmentsPage,
});

function AppointmentsPage() {
  const { t } = useTranslation("appointments");
  const { user } = useAuth();
  const canCreate = user ? ["gutachter", "assistent", "administrator", "super_admin"].includes(user.role) : false;
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{t("title")}</h1>
          <p className="text-muted-foreground">
            {t("subtitle")}
          </p>
        </div>
        {canCreate && (
          <Link to="/appointments/new">
            <Button>
              <Plus className="mr-2 h-4 w-4" />
              {t("newAppointment")}
            </Button>
          </Link>
        )}
      </div>

      <AppointmentList />
    </div>
  );
}
